import { render } from "./AppDetails.vue?vue&type=template&id=04b2cc7f"
import script from "./AppDetails.vue?vue&type=script&lang=ts"
export * from "./AppDetails.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QSpace from 'quasar/src/components/space/QSpace.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpace});
